<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1"> </p>
<p class="vept">HALCYON DAYS</p>
<p class="v"><span class="epub-i">Not from successful love alone,</span></p>
<p class="v"><span class="epub-i">Nor wealth, nor honor’d middle age, nor victories of politics or war;</span></p>
<p class="v"><span class="epub-i">But as life wanes, and all the turbulent passions calm,</span></p>
<p class="v"><span class="epub-i">As gorgeous, vapory, silent hues cover the evening sky,</span></p>
<p class="v"><span class="epub-i">As softness, fullness, rest, suffuse the frame, like fresher, balmier air,</span></p>
<p class="v"><span class="epub-i">As the days take on a mellower light, and the apple at last hangs really finish’d and indolent-ripe on the tree,</span></p>
<p class="v"><span class="epub-i">Then for the teeming quietest, happiest days of all!</span></p>
<p class="v"><span class="epub-i">The brooding and blissful halcyon days!</span></p>
<p class="vepc"><span class="epub-i">—Walt Whitman, at seventy</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?e4fb8e30